import { useOrdersTableDisplay } from "./useOrdersTableDisplay";

export const useOrdersDisplayMenuController = () => {
  const {
    density,
    horizontalLines,
    verticalLines,
    setDensity,
    setHorizontalLines,
    setVerticalLines,
  } = useOrdersTableDisplay();

  return {
    density,
    horizontalLines,
    verticalLines,
    onDensityChange: setDensity,
    onHorizontalLinesChange: setHorizontalLines,
    onVerticalLinesChange: setVerticalLines,
  };
};
